import { useAuth } from "../App";

const translations = {
  pt: {
    // Common
    loading: "A carregar...",
    save: "Guardar",
    cancel: "Cancelar",
    close: "Fechar",
    delete: "Eliminar",
    confirm: "Confirmar",
    back: "Voltar",
    search: "Pesquisar",
    // Auth
    logout: "Terminar Sessão",
    profile: "Perfil",
    switchToEn: "Switch to EN",
    switchToPt: "Mudar para PT",
    // Navigation
    home: "Início",
    lessons: "Aulas",
    enrollments: "Inscrições",
    progress: "Progresso",
    logbook: "Caderneta",
    // Student Dashboard
    hello: "Olá",
    groupCredits: "Créditos Grupo",
    privateCredits: "Créditos Privados",
    scheduledLessons: "Aulas Agendadas",
    buyLessons: "Comprar Aulas",
    availableLessons: "Aulas Disponíveis",
    viewAll: "Ver todas",
    noAvailableLessons: "Não há aulas disponíveis de momento.",
    myUpcomingLessons: "Minhas Próximas Aulas",
    enroll: "Inscrever",
    enrolled: "Inscrito",
    reserved: "Reservado",
    attended: "Presente",
    full: "Lotada",
    cancelEnrollment: "Cancelar",
    // Lessons Page
    noLessonsToday: "Sem aulas neste dia",
    // Enrollments Page
    myEnrollments: "Minhas Inscrições",
    noEnrollments: "Sem inscrições",
    cancelled: "Cancelado",
    // Progress Page
    myProgress: "Meu Progresso",
    rankingSurf: "Ranking Surf",
    rankingBodyboard: "Ranking Bodyboard",
    teacherReviews: "Reviews dos Professores",
    noReviews: "Ainda sem reviews",
    improvementTips: "Dicas de melhoria",
    // Packs Store
    buyLessonsTitle: "Comprar Aulas",
    choosePack: "Escolhe o pack ideal para ti",
    groupLessons: "Aulas de Grupo",
    privateLessons: "Aulas Privadas",
    buy: "Comprar",
    securePayment: "Pagamento seguro via Stripe. Cartão e MBWay.",
    popular: "Popular",
    private: "Privada",
    perPerson: "/ pessoa",
    groupCreditsLabel: "créditos grupo",
    privateCreditsLabel: "créditos privados",
    // Activity
    surf: "Surf",
    bodyboard: "Bodyboard",
    selectActivity: "Escolhe a modalidade",
    activityLabel: "Modalidade",
    // Booking
    reservedNoCredits: "Aula reservada!",
    reservedDescription: "Reserva feita sem créditos (máx. 1 ativa). Compra créditos para confirmar.",
    enrollSuccess: "Inscrição realizada com sucesso!",
    noCreditsReservation: "Sem créditos e já tens uma reserva ativa!",
    cancelSuccess: "Inscrição cancelada",
    errorEnroll: "Erro ao inscrever",
    errorCancel: "Erro ao cancelar inscrição",
    errorLoad: "Erro ao carregar dados",
    errorLanguage: "Erro ao alterar idioma",
    langChangedPt: "Idioma alterado para Português",
    langChangedEn: "Language changed to English",
    // Group/Private type
    group: "Grupo",
    privateLesson: "Privada",
    // Misc
    teachers: "Professores",
    students: "Alunos",
    lesson: "aula",
    lessonsPlural: "aulas",
  },
  en: {
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    delete: "Delete",
    confirm: "Confirm",
    back: "Back",
    search: "Search",
    logout: "Log Out",
    profile: "Profile",
    switchToEn: "Switch to EN",
    switchToPt: "Mudar para PT",
    home: "Home",
    lessons: "Lessons",
    enrollments: "Enrollments",
    progress: "Progress",
    logbook: "Logbook",
    hello: "Hello",
    groupCredits: "Group Credits",
    privateCredits: "Private Credits",
    scheduledLessons: "Scheduled Lessons",
    buyLessons: "Buy Lessons",
    availableLessons: "Available Lessons",
    viewAll: "View all",
    noAvailableLessons: "No lessons available at the moment.",
    myUpcomingLessons: "My Upcoming Lessons",
    enroll: "Enroll",
    enrolled: "Enrolled",
    reserved: "Reserved",
    attended: "Attended",
    full: "Full",
    cancelEnrollment: "Cancel",
    noLessonsToday: "No lessons on this day",
    myEnrollments: "My Enrollments",
    noEnrollments: "No enrollments",
    cancelled: "Cancelled",
    myProgress: "My Progress",
    rankingSurf: "Surf Ranking",
    rankingBodyboard: "Bodyboard Ranking",
    teacherReviews: "Teacher Reviews",
    noReviews: "No reviews yet",
    improvementTips: "Improvement tips",
    buyLessonsTitle: "Buy Lessons",
    choosePack: "Choose the ideal pack for you",
    groupLessons: "Group Lessons",
    privateLessons: "Private Lessons",
    buy: "Buy",
    securePayment: "Secure payment via Stripe. Card and MBWay.",
    popular: "Popular",
    private: "Private",
    perPerson: "/ person",
    groupCreditsLabel: "group credits",
    privateCreditsLabel: "private credits",
    surf: "Surf",
    bodyboard: "Bodyboard",
    selectActivity: "Choose activity",
    activityLabel: "Activity",
    reservedNoCredits: "Lesson reserved!",
    reservedDescription: "Reserved without credits (max. 1 active). Buy credits to confirm.",
    enrollSuccess: "Enrollment successful!",
    noCreditsReservation: "No credits and you already have an active reservation!",
    cancelSuccess: "Enrollment cancelled",
    errorEnroll: "Error enrolling",
    errorCancel: "Error cancelling enrollment",
    errorLoad: "Error loading data",
    errorLanguage: "Error changing language",
    langChangedPt: "Idioma alterado para Português",
    langChangedEn: "Language changed to English",
    group: "Group",
    privateLesson: "Private",
    teachers: "Teachers",
    students: "Students",
    lesson: "lesson",
    lessonsPlural: "lessons",
  },
};

export function useTranslation() {
  const { user } = useAuth();
  const lang = user?.language || "pt";
  const t = (key) => translations[lang]?.[key] || translations.pt[key] || key;
  return { t, lang };
}
